import {useIntl} from "@irati/utils/lang"
import React from "react"
import PermissionOption from "./PermissionOption"

const defaultProps = {
  id: "walletRequestPoints",
  name: "canRequestPoints",
  action: "canRequestPoints"
}
const RequestPointsOptions = (props = defaultProps) => {
  const intl = useIntl()
  return (
    <PermissionOption
      {...props}
      label={intl.formatMessage({id: "admin.requestPointsOptions.label"})}
      description={intl.formatMessage({id: "admin.requestPointsOptions.desc"})}
      placeholder={intl.formatMessage({id: "admin.requestPointsOptions.placeholder"})}
    />
  )
}
RequestPointsOptions.defaultProps = defaultProps
export default RequestPointsOptions
